import axios from 'axios';

function buildApiBaseUrl() {
  const raw = (
    process.env.REACT_APP_API_URL ||
    process.env.REACT_APP_BACKEND_URL ||
    ''
  )
    .trim()
    .replace(/\/+$/, '');

  if (!raw) {
    console.error(
      'REACT_APP_API_URL/REACT_APP_BACKEND_URL não estão definidas. Usando fallback local /api.'
    );
    return '/api';
  }

  if (/\/api$/i.test(raw)) {
    return raw;
  }

  return `${raw}/api`;
}

export const API_BASE_URL = buildApiBaseUrl();

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem('token') ||
      localStorage.getItem('access_token') ||
      localStorage.getItem('authToken');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const activeTenantId = localStorage.getItem('active_tenant_id');
    if (activeTenantId) {
      config.headers['X-Tenant-Id'] = activeTenantId;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('access_token');
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      localStorage.removeItem('active_tenant_id');
      localStorage.removeItem('active_tenant_name');
      localStorage.removeItem('active_tenant_slug');
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default api;
